var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appContainer"},[(_vm.$mq=='lg')?_c('Header'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"errorContent center"},[_c('router-view')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }